import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { truncateText, HERO_MAX_DESC_LENGTH } from 'helpers/ContentHelper';
import style from './Description.module.scss';

const Description = ({ description, theme = {} }) => {
  const [descriptionOpen, toggleDescriptionOpen] = useState(false);
  const {
    global_lessButton: descriptionLessText,
    global_moreButton: descriptionMoreText,
  } = window.Language;

  const isDescriptionLong = description && description.length > HERO_MAX_DESC_LENGTH;
  const descriptionText = descriptionOpen
    ? description
    : truncateText(description, HERO_MAX_DESC_LENGTH);

  const descriptionButtonClasses = [style.descriptionButton, theme.descriptionButton];
  const descriptionButtonText = descriptionOpen ? descriptionLessText : descriptionMoreText;

  const descriptionButton = isDescriptionLong ? (
    <button
      className={classNames(descriptionButtonClasses)}
      onClick={event => {
        event.preventDefault();
        event.stopPropagation();
        toggleDescriptionOpen(!descriptionOpen);
      }}
    >
      {descriptionButtonText}
    </button>
  ) : null;

  return (
    <div className={(style.descriptionContainer, theme.descriptionContainer)}>
      <div
        className={classNames(style.description, theme.description)}
        data-test="hero-description"
      >
        {descriptionText}
        {descriptionButton}
      </div>
    </div>
  );
};

Description.propTypes = {
  description: PropTypes.string,
  theme: PropTypes.shape({}),
};

export default Description;
